import React, { useState } from "react";
import api from "../utils/api";

const StatusToggle = ({ status, setStatus }) => {
  const [loading, setLoading] = useState(false);
  const [pendingStatus, setPendingStatus] = useState(null);

  const requestToggle = () => {
    const newStatus = status === "online" ? "offline" : "online";
    setPendingStatus(newStatus);
  };

  const confirmToggle = async () => {
    const newStatus = pendingStatus;
    setPendingStatus(null);
    setLoading(true);
    try {
      await api.post("/settings/restaurantstatus", { status: newStatus });
      setStatus(newStatus);
    } catch (error) {
      console.error("Failed to update status:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-2 md:gap-4 bg-gray-50 px-2 md:px-4 py-2 rounded-lg border border-gray-200">
      {/* Status Indicator */}
      <div className="flex items-center gap-1 md:gap-2">
        <div className="relative">
          <div
            className={`w-2 h-2 md:w-3 md:h-3 rounded-full ${status === "online" ? "bg-green-500" : "bg-red-500"}`}
          ></div>
          {status === "online" && (
            <div className="absolute inset-0 w-2 h-2 md:w-3 md:h-3 rounded-full bg-green-500 animate-ping opacity-75"></div>
          )}
        </div>
        <span className="font-text text-xs md:text-sm font-medium text-gray-700">
          Online Orders
        </span>
      </div>

      {/* Toggle Switch */}
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={status === "online"}
          onChange={requestToggle}
          disabled={loading}
        />
        <div
          className={`
          w-10 md:w-14 h-5 md:h-7 bg-gray-300 rounded-full peer
          peer-checked:bg-green-500
          peer-focus:ring-4 peer-focus:ring-green-300
          after:content-[''] after:absolute after:top-0.5 after:left-[2px] md:after:left-[4px]
          after:bg-white after:rounded-full after:h-4 after:w-4 md:after:h-6 md:after:w-6
          after:transition-all after:shadow-md
          peer-checked:after:translate-x-full
          ${loading ? "opacity-50 cursor-not-allowed" : ""}
        `}
        ></div>
      </label>

      {/* Status Text */}
      <span
        className={`font-text text-xs md:text-sm font-semibold ${
          status === "online" ? "text-green-600" : "text-red-600"
        }`}
      >
        {status === "online" ? "On" : "Off"}
      </span>

      {/* Confirmation Dialog */}
      {pendingStatus && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-xl shadow-xl w-[90%] max-w-[400px] mx-4">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-bold text-gray-900">
                Turn Online Orders {pendingStatus === "online" ? "On" : "Off"}
              </h3>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-700">
                {pendingStatus === "online"
                  ? "Customers will be able to place online and takeaway orders again. Continue?"
                  : "Customers will not be able to place online or takeaway orders. Dine-in and QR table orders keep working. Continue?"}
              </p>
            </div>
            <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-2">
              <button
                onClick={() => setPendingStatus(null)}
                className="px-4 py-2 border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmToggle}
                className={`px-4 py-2 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all ${
                  pendingStatus === "online"
                    ? "bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800"
                    : "bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
                }`}
              >
                Yes, Turn {pendingStatus === "online" ? "On" : "Off"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusToggle;
